import _Promise from "@babel/runtime-corejs3/core-js/promise";
import store from "../../store";
import { getRouteMetaValue, loadCSS } from "@Shared/@Utils/utils";
import { ERROR_HEADER, showToast, TOASTR_ERROR_OPTIONS } from "@Shared/@Utils/constants";
import { isEmpty } from "lodash";
import { EXTERNAL_SERVICE_NAME } from "@Shared/@Types/status-page/types";
export const allowIfPendingValidation = (to, from, next) => {
  const {
    verification: {
      pendingEmailVerification
    }
  } = store.state.AccountStore;
  if (!pendingEmailVerification) {
    next(false);
    return;
  }
  return true;
};
export const verifySession = (to, from, next) => {
  const {
    token
  } = store.state.AccountStore;
  if (!token) {
    const routeRedirectName = getRouteMetaValue(to, "routeRedirectName") || "login";
    next({
      name: routeRedirectName,
      query: {
        state: to.path || ""
      }
    });
    return;
  }
  return true;
};
export const loadCustomStyles = async () => {
  if (document.getElementById("custom-styles-stylesheet")) return;
  const path = window.location.pathname.replace("/", "").replace("#", "");
  const link = loadCSS(path, true);
  return new _Promise(resolve => {
    link.onload = () => {
      resolve(true);
    };
    link.onerror = () => {
      showToast("error", "errorWhileLoadingStyles", ERROR_HEADER, TOASTR_ERROR_OPTIONS);
      resolve(true);
    };
  });
};
export const checkForRedirects = () => {
  return true;
};
export const checkApplications = async (to, from, next) => {
  const {
    selectedApplicationId
  } = store.state.AccountStore;
  if (!selectedApplicationId) {
    next({
      name: "subdomain-interstitial",
      query: {
        force: true
      }
    });
    return;
  }
  const {
    applications
  } = store.state.DeprecatedApplicationStore;
  if (isEmpty(applications.byId)) {
    await store.dispatch("DeprecatedApplicationStore/LOAD_APPLICATIONS_FROM_SUBDOMAIN", {});
  }
  return true;
};
export const allowIfNoSession = (to, from, next) => {
  const {
    token
  } = store.state.AccountStore;
  if (token) {
    const routeRedirectName = getRouteMetaValue(to, "routeRedirectName") || "home";
    next({
      name: routeRedirectName
    });
    return;
  }
  return true;
};
export const checkIfGlobalMaintenanceMode = async (to, from, next) => {
  try {
    await store.dispatch("StatusPageStore/LOAD_EXTERNAL_SERVICES_STATUS", EXTERNAL_SERVICE_NAME.GLOBAL);
    const globalMaintenanceInProgress = store.getters["StatusPageStore/GLOBAL_MAINTENANCE_IN_PROGRESS"];
    if (globalMaintenanceInProgress && from.name === "maintenance-message") {
      next(false);
      return;
    }
    if (globalMaintenanceInProgress) {
      next({
        name: "maintenance-message"
      });
      return;
    }
  } catch (_unused) {
    // Do nothing
  }
  return true;
};